// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__30d1x","addWidgetButton":"Header_addWidgetButton__2wX_O","dashboardTabs":"Header_dashboardTabs__1-5CM","active":"Header_active__j7Cd_"};